import { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { CenterModalWrapper } from '@/components/ModalTypes/center';
import { MoneyField } from '@/components/UI/MoneyField';
import { useGetFundraisingStatus } from '@/query/queries/fundraising/useGetFundraisingStatus';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const GoalEditModal = ({ onClose }) => {
  const { data: status } = useGetFundraisingStatus();
  const { values, setFieldValue } = useFormikContext();
  const [amount, setAmount] = useState(values.new_funds || 0);
  const [error, setError] = useState('');
  const { t } = useTranslation('fundraising');

  const onChange = newAmount => {
    setError(() => '');
    if (Number(newAmount) > Number(status?.max_new_funds)) {
      return setError(
        t('goal_edit_modal.amount_should_be_less_than', {
          max: prettyFloatMoney(status?.max_new_funds),
        }),
      );
    }
    setFieldValue('new_funds', newAmount);
    onClose();
  };

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Enter') {
        onChange(amount);
      }
    },
    [amount],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <CenterModalWrapper onClose={onClose}>
      <div className={s.wrapper}>
        <h2 className="f-h2 f-500">{t('goal_edit_modal.edit_your_goal')}</h2>
        <MoneyField
          name="new_funds"
          label={t('goal_edit_modal.please_enter_desired_amount')}
          onChange={(_, amount) => {
            setError(() => '');
            setAmount(amount);
          }}
          value={amount}
          onClear={() => setAmount(0)}
          error={error}
        />
        <button
          type="button"
          onClick={() => onChange(amount)}
          onKeyDown={e => handleKeyDown(e, amount)}
          className={classnames(r.black_large, s.save_btn)}
        >
          {t('goal_edit_modal.save')}
        </button>
      </div>
    </CenterModalWrapper>
  );
};
